(() => {
  // The live page template predates the current section wrapper. Fall back to
  // the document so the session card still initializes on that markup.
  const root = document.querySelector('[data-st-go-hub]') || document;

  const timeZone = 'America/New_York';
  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  });
  const zonedParts = date => Object.fromEntries(dateFormatter.formatToParts(date).map(part => [part.type, part.value]));
  const dateKey = (date, dayOffset = 0) => {
    const parts = zonedParts(date);
    const calendarDate = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day) + dayOffset));
    return [calendarDate.getUTCFullYear(), String(calendarDate.getUTCMonth() + 1).padStart(2, '0'), String(calendarDate.getUTCDate()).padStart(2, '0')].join('-');
  };
  const easternMidnightAfter = date => {
    const nextDate = dateKey(date, 1).split('-').map(Number);
    const targetUtc = Date.UTC(nextDate[0], nextDate[1] - 1, nextDate[2]);
    let guess = targetUtc;
    for (let attempt = 0; attempt < 3; attempt += 1) {
      const parts = zonedParts(new Date(guess));
      const representedUtc = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second));
      guess += targetUtc - representedUtc;
    }
    return guess;
  };
  const hash = text => {
    let value = 2166136261;
    for (let i = 0; i < text.length; i += 1) value = Math.imul(value ^ text.charCodeAt(i), 16777619);
    return value >>> 0;
  };
  const duration = seconds => Math.max(1, Math.floor(Number(seconds) / 60)) + ' min';
  const title = root.querySelector('[data-daily-title]');
  const image = root.querySelector('[data-daily-image]');
  const runtime = root.querySelector('[data-daily-duration], [data-daily-time]');
  const cta = root.querySelector('[data-daily-cta]');
  const error = root.querySelector('[data-daily-error]');

  const renderDailySession = sessions => {
    const today = dateKey(new Date());
    const yesterday = dateKey(new Date(), -1);
    let index = hash('sweat-therapy-' + today) % sessions.length;
    const priorIndex = hash('sweat-therapy-' + yesterday) % sessions.length;
    if (index === priorIndex && sessions.length > 1) index = (index + 1) % sessions.length;
    const session = sessions[index];
    if (!session) return;

    if (image) {
      image.src = session.thumbnail || 'https://i.ytimg.com/vi/' + encodeURIComponent(session.id) + '/hqdefault.jpg';
      image.alt = '';
    }
    if (title) title.textContent = session.title;
    if (runtime) runtime.textContent = duration(session.durationSeconds);
    if (!cta) return;
    cta.href = 'https://www.youtube.com/watch?v=' + encodeURIComponent(session.id);
    cta.dataset.goName = session.title;
    if (error) error.hidden = true;
  };

  const scriptUrl = [...document.scripts].find(script => script.src.includes('/st-social-hub.js'))?.src;
  const catalogAssetUrl = scriptUrl ? new URL('st-go-public-sessions.json', scriptUrl) : null;
  if (catalogAssetUrl && new URL(scriptUrl).searchParams.has('v')) {
    catalogAssetUrl.searchParams.set('v', new URL(scriptUrl).searchParams.get('v'));
  }
  const catalogUrl = root.dataset?.catalogUrl || catalogAssetUrl?.href;
  if (catalogUrl) {
    fetch(catalogUrl, { credentials: 'same-origin' })
      .then(response => {
        if (!response.ok) throw new Error('Unable to load the session list');
        return response.json();
      })
      .then(catalog => {
        const sessions = (catalog.publicSessions || []).filter(session =>
          session.id && session.title && Number(session.durationSeconds) > 0
        );
        if (!sessions.length) throw new Error('No public sessions are available');
        renderDailySession(sessions);
        let renderedDate = dateKey(new Date());
        let midnightTimer;
        const refreshIfDateChanged = () => {
          const currentDate = dateKey(new Date());
          if (currentDate !== renderedDate) {
            renderDailySession(sessions);
            renderedDate = currentDate;
          }
        };
        const scheduleNextMidnight = () => {
          window.clearTimeout(midnightTimer);
          const delay = Math.max(0, easternMidnightAfter(new Date()) - Date.now() + 25);
          midnightTimer = window.setTimeout(() => {
            refreshIfDateChanged();
            scheduleNextMidnight();
          }, delay);
        };
        scheduleNextMidnight();
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            refreshIfDateChanged();
            scheduleNextMidnight();
          }
        });
      })
      .catch(() => {
        if (error) error.hidden = false;
      });
  } else if (error) {
    error.hidden = false;
  }

  const query = new URLSearchParams(window.location.search);
  const source = query.get('utm_source') || query.get('source') || document.referrer || 'direct';
  root.querySelectorAll('[data-go-link]').forEach(link => {
    link.addEventListener('click', () => {
      const payload = {
        source,
        link_group: link.dataset.goGroup || 'other',
        link_name: link.dataset.goName || link.textContent.trim(),
        destination: link.href,
        page: window.location.pathname,
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'social_hub_link_click', ...payload });
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish('social_hub_link_click', payload);
      }
    });
  });
})();